import React, { useState, useEffect, useRef } from 'react';

import './critical.scss';

const AdditionalLocalitiesList = ({ additionalLocalities, isQBLocalitySearch }) => {
  const listRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [listHeight, setListHeight] = useState(0);

  useEffect(() => {
    if (listRef.current) {
      setListHeight(listRef.current.clientHeight);
    }
  }, []);

  useEffect(() => {
    if (isOpen && listRef.current) {
      setListHeight(listRef.current.scrollHeight);
    }
  }, [isOpen]);

  const openList = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const size = isQBLocalitySearch ? '' : ' tp-s--s';
  const weight = isQBLocalitySearch ? ' tp-w--m' : ' tp-w--m';
  const padding = isQBLocalitySearch ? '' : ' pl--ls';

  return (
    <>
      <ul
        ref={listRef}
        className={`add-locs-list pt--xs${size}${padding}`} style={{ maxHeight: listHeight || null }}        
      >
        {(isOpen ? additionalLocalities : additionalLocalities.slice(0, 4)).map(
          (c, index) => (
            <li
              key={c.hkey}
              className={`c-txt--f0${weight}`}
              onClick={index === 3 && additionalLocalities.length > 4 && !isOpen ? openList : undefined}
            >
              <span>•</span>
              <span>
                {c.name} 
                {index === 3 && additionalLocalities.length > 4 && !isOpen ? ' [...]' : null}
              </span>
            </li>
          ))}
      </ul>
      
    </>
  );
};

export default AdditionalLocalitiesList;